/**
 * SVG path data for the chevrons right icon.
 */
export const chevronsRight = {
    paths: [
        {
            d: 'M10.21 4.23a.75.75 0 0 1 1.06.02l5 5a.75.75 0 0 1 0 1.04l-5 5.5a.75.75 0 1 1-1.12-1.04L14.586 10l-4.436-4.75a.75.75 0 0 1 .06-1.02z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
        {
            d: 'M4.21 4.23a.75.75 0 0 1 1.06.02l5 5a.75.75 0 0 1 0 1.04l-5 5.5a.75.75 0 1 1-1.12-1.04L8.586 10 4.15 5.25a.75.75 0 0 1 .06-1.02z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
};
//# sourceMappingURL=chevrons-right.js.map